import { render, staticRenderFns } from "./PolicyHolderView.vue?vue&type=template&id=155e4e48&"
import script from "./PolicyHolderView.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports